export default {"src":"/_next/static/media/grapes.dc5dd453.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};